import { lazy } from "react";

const CreateNotiContentPage = lazy(() => import("./create"));
const NotiContentListPage = lazy(() => import("./main"));
const UpdateNotiContentPage = lazy(() => import("./update"));

export {
  CreateNotiContentPage, NotiContentListPage, UpdateNotiContentPage,
};
